import React from "react";

import { AppUserSession } from "@/schemas/auth/session";
import { RecommendationCategoryFeed } from "@/schemas/user/explore";
import ExploreCategoryScreenBase from "@/screens/Explore/ExploreCategory/Components/CategoryScreen/ExploreByCategoryScreenBase";
import LargeProfileCard from "@/screens/Explore/Components/ProfileCard/LargeProfileCard";

type Props = {
  session: AppUserSession;
  categoryData: RecommendationCategoryFeed;
  isDevTab?: boolean;
  isMarketingMode?: boolean;
};

function ExploreOneColumnCategoryScreen({
  session,
  categoryData,
  isDevTab = false,
  isMarketingMode = false,
}: Props): React.JSX.Element {
  return (
    <ExploreCategoryScreenBase
      session={session}
      categoryData={categoryData}
      isDevTab={isDevTab}
      isMarketingMode={isMarketingMode}
      numOfColumns={1}
      renderProfileCard={({ item, itemWidth, itemHeight }) => (
        <LargeProfileCard
          profile={item}
          itemWidth={itemWidth}
          itemHeight={itemHeight}
        />
      )}
    />
  );
}

export default ExploreOneColumnCategoryScreen;
